import { CreateWorkOrderDto, WorkOrder } from "@myapp/contract";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { workOrderApi } from "../service";
import { workOrderKeys } from "../work-order.keys";
import { auditLogKeys } from "../../../audit-log";

export function useCreateWorkOrder() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (dto: CreateWorkOrderDto) => {
      const { data } = await workOrderApi.create(dto);
      return data as WorkOrder;
    },
    onSuccess: (_data, dto) => {
      queryClient.invalidateQueries({ queryKey: workOrderKeys.lists() });
      queryClient.invalidateQueries({ queryKey: auditLogKeys.byWorkOrder(dto.workOrderId) });
    },
  });
}
